/* ============================================================
   ways-to-play.js — Ways to Play tab 面板 + AI Jam 互动
   对应 sections/ways-to-play.liquid（同名拆分）。
   - tab 切换（class/aria/键盘方向键）；面板视频懒加载、激活播放、离屏暂停
   - AI Jam：Spin 随机换预设 → Generate 播放结果视频 + 音频预览
   - 预设数据来自 [data-ways-presets] JSON，UI 文案来自 [data-ways-i18n]
   ============================================================ */
(function () {
  'use strict';

  function initSection(section) {
    var tabs = Array.from(section.querySelectorAll('[data-ways-tab]'));
    var panels = Array.from(section.querySelectorAll('[data-ways-panel]'));
    if (!tabs.length || !panels.length) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var i18nEl = section.querySelector('[data-ways-i18n]');
    var i18n = i18nEl ? i18nEl.dataset : {};
    var visible = false;
    var activeKey = panels[0].dataset.waysPanel;
    var jam = null;

    function stopVideo(video) {
      video.pause();
      try { video.currentTime = 0; } catch (e) { /* metadata 未就绪 */ }
    }

    function stopAllMedia() {
      section.querySelectorAll('video').forEach(stopVideo);
      if (jam) jam.stop();
    }

    function playPanelVideo(panel) {
      if (!panel || reducedMotion.matches || !visible) return;
      var video = panel.querySelector('[data-ways-video]');
      if (!video) return;
      if (!video.getAttribute('src') && video.dataset.waysSrc) {
        video.src = video.dataset.waysSrc;
        video.load();
      }
      video.muted = true;
      video.play().catch(function () {});
    }

    /* ── AI Jam 老虎机（对照旧站 compiled ai-jam 模块重写） ── */
    function createJam() {
      var panel = section.querySelector('[data-ways-jam-panel]');
      var root = section.querySelector('[data-ways-jam]');
      if (!panel || !root) return null;

      var presets = [];
      try {
        presets = JSON.parse(section.querySelector('[data-ways-presets]').textContent);
      } catch (e) {
        presets = [];
      }
      if (!presets.length) return null;

      var ITEM_H = 80;
      var DECOR = {
        tone: ['Lo-Fi', 'Clean'],
        genre: ['Jazz'],
        vibe: ['Chill', 'All-time']
      };
      function buildItems(key) {
        var values = [];
        presets.forEach(function (p) {
          if (values.indexOf(p[key]) === -1) values.push(p[key]);
        });
        var pool = values.concat(DECOR[key] || []);
        var items = [];
        var idx = 0;
        while (items.length < 8) {
          items.push(pool[idx % pool.length]);
          idx++;
        }
        return items;
      }
      var REELS = [
        { key: 'tone', label: i18n.labelTone || 'Tone', items: buildItems('tone') },
        { key: 'genre', label: i18n.labelGenre || 'Genre', items: buildItems('genre') },
        { key: 'vibe', label: i18n.labelVibe || 'Vibe', items: buildItems('vibe') }
      ];

      var reelsEl = root.querySelector('[data-jam-reels]');
      var spinBtn = root.querySelector('[data-jam-spin]');
      var resetBtn = root.querySelector('[data-jam-reset]');
      var statusEl = root.querySelector('[data-jam-status]');
      var dotEl = root.querySelector('[data-jam-dot]');
      var canvas = root.querySelector('[data-jam-wave]');
      if (!reelsEl || !spinBtn || !statusEl) return null;

      var trackEls = [];
      var currentPreset = null;
      var isSpinning = false;
      var isPlaying = false;
      var audio = null;
      var idlePhase = 0;
      var playPhase = 0;

      // 构建 3 个转轮（items × 6 循环带，起始停在中段）
      REELS.forEach(function (reel, ri) {
        var wrap = document.createElement('div');
        wrap.className = 'aij__reel';
        wrap.setAttribute('data-jam-reel-index', ri);
        var lbl = document.createElement('p');
        lbl.className = 'aij__reel-label';
        lbl.textContent = reel.label;
        var win = document.createElement('div');
        win.className = 'aij__reel-window';
        var centerLine = document.createElement('div');
        centerLine.className = 'aij__center-line';
        win.appendChild(centerLine);
        var track = document.createElement('div');
        track.className = 'aij__reel-track';
        for (var rep = 0; rep < 6; rep++) {
          reel.items.forEach(function (item) {
            var el = document.createElement('div');
            el.className = 'aij__reel-item';
            el.textContent = item;
            track.appendChild(el);
          });
        }
        win.appendChild(track);
        wrap.appendChild(lbl);
        wrap.appendChild(win);
        reelsEl.appendChild(wrap);
        trackEls.push({ track: track, reel: reel, wrap: wrap });
        track.style.transform = 'translateY(' + (-reel.items.length * ITEM_H * 2) + 'px)';
      });

      function spinReel(ri, targetItem, delay) {
        return new Promise(function (resolve) {
          setTimeout(function () {
            var entry = trackEls[ri];
            var track = entry.track;
            var reel = entry.reel;
            var targetIdx = reel.items.indexOf(targetItem);
            if (targetIdx === -1) targetIdx = 0;
            var baseRow = reel.items.length * 4 + targetIdx;
            var finalY = -(baseRow * ITEM_H);
            var startY = parseInt(track.style.transform.replace(/[^-\d]/g, ''), 10) || 0;
            var spinDist = reel.items.length * ITEM_H * 3;
            var duration = 900 + ri * 180;
            var startTime = performance.now();

            function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
            function frame(now) {
              var t = Math.min((now - startTime) / duration, 1);
              var y;
              if (t < 0.6) {
                var eased = t < 0.7 ? (t / 0.7) * 0.85 : 0.85 + 0.15 * easeOut((t - 0.7) / 0.3);
                y = startY - spinDist * (eased / 0.85);
              } else {
                var decel = easeOut((t - 0.6) / 0.4);
                var midY = startY - spinDist * 0.85;
                y = midY + (finalY - midY) * decel;
              }
              track.style.transform = 'translateY(' + y + 'px)';
              if (t < 1) {
                requestAnimationFrame(frame);
              } else {
                track.style.transform = 'translateY(' + finalY + 'px)';
                var allItems = track.querySelectorAll('.aij__reel-item');
                allItems.forEach(function (el, i) {
                  el.classList.toggle('is-landed', i === baseRow);
                });
                entry.wrap.classList.add('is-locked');
                resolve();
              }
            }
            requestAnimationFrame(frame);
          }, delay);
        });
      }

      function setSpinBtn(mode, preset) {
        spinBtn.classList.remove('is-italic', 'is-playing');
        spinBtn.style.background = '';
        spinBtn.style.boxShadow = '';
        if (mode === 'spinning') {
          spinBtn.disabled = true;
          spinBtn.textContent = i18n.btnSpinning || 'Spinning...';
        } else if (mode === 'generate') {
          spinBtn.disabled = false;
          spinBtn.textContent = i18n.btnGenerate || 'Generate & Jam';
          spinBtn.classList.add('is-italic');
          if (preset && preset.color) {
            spinBtn.style.background = preset.color;
            spinBtn.style.boxShadow = '0 8px 32px ' + preset.color + '55';
          }
        } else if (mode === 'loading') {
          spinBtn.disabled = true;
          spinBtn.textContent = i18n.btnLoading || 'Loading...';
        } else if (mode === 'stop') {
          spinBtn.disabled = false;
          spinBtn.textContent = i18n.btnStop || '⏹  Stop';
          spinBtn.classList.add('is-playing');
        } else {
          spinBtn.disabled = false;
          spinBtn.textContent = i18n.btnSpinCta || 'Spin & Jam';
          spinBtn.classList.add('is-italic');
        }
      }

      function statusReady(preset) {
        statusEl.textContent = (i18n.msgReady || '"{name}" — hit Generate & Jam to play').replace('{name}', preset.name);
      }

      function doSpin() {
        if (isSpinning) return;
        if (isPlaying) stopAudio();
        isSpinning = true;
        setSpinBtn('spinning');
        statusEl.textContent = i18n.msgSpinning || 'Generating your combo...';
        if (dotEl) dotEl.style.display = 'none';
        root.querySelectorAll('[data-jam-pill]').forEach(function (el) {
          el.classList.remove('is-visible', 'is-lit');
        });
        trackEls.forEach(function (entry) {
          entry.wrap.classList.remove('is-locked');
        });
        root.querySelectorAll('.aij__reel-item').forEach(function (el) {
          el.classList.remove('is-landed');
        });

        var available = presets.filter(function (p) { return p !== currentPreset; });
        if (!available.length) available = presets;
        var preset = available[Math.floor(Math.random() * available.length)];
        var targets = [preset.tone, preset.genre, preset.vibe];

        Promise.all([
          spinReel(0, targets[0], 0),
          spinReel(1, targets[1], 220),
          spinReel(2, targets[2], 440)
        ]).then(function () {
          ['tone', 'genre', 'vibe'].forEach(function (k, i) {
            setTimeout(function () {
              var el = root.querySelector('[data-jam-pill="' + k + '"]');
              if (!el) return;
              el.textContent = targets[i];
              el.classList.add('is-visible');
              el.style.setProperty('--pill-accent', preset.color || '');
              setTimeout(function () { el.classList.add('is-lit'); }, 120);
            }, i * 120);
          });
          setTimeout(function () {
            setSpinBtn('generate', preset);
            if (dotEl && preset.color) dotEl.style.background = preset.color;
            statusReady(preset);
            isSpinning = false;
            if (resetBtn) resetBtn.disabled = false;
            currentPreset = preset;
          }, 3 * 120 + 200);
        });
      }

      function startAudio(preset) {
        setSpinBtn('loading');
        stopAudio(false);
        audio = new Audio();
        audio.loop = true;
        audio.src = preset.audio;
        audio.addEventListener('error', function () {
          setSpinBtn('generate', preset);
          statusEl.textContent = i18n.msgAudioError || '⚠ Audio failed to load';
          isPlaying = false;
        }, { once: true });
        audio.play().then(function () {
          isPlaying = true;
          setSpinBtn('stop');
          if (resetBtn) resetBtn.disabled = true;
          if (dotEl) dotEl.style.display = 'block';
          statusEl.textContent = (i18n.msgPlaying || 'Now playing: "{name}"').replace('{name}', preset.name);
        }).catch(function () {
          setSpinBtn('generate', preset);
          statusEl.textContent = i18n.msgRetry || '⚠ Tap again to retry playback';
          isPlaying = false;
        });
      }

      function stopAudio(resetUI) {
        if (resetUI === undefined) resetUI = true;
        if (audio) {
          audio.pause();
          audio.currentTime = 0;
          audio = null;
        }
        isPlaying = false;
        if (dotEl) dotEl.style.display = 'none';
        if (resetUI && currentPreset) {
          setSpinBtn('generate', currentPreset);
          if (resetBtn) resetBtn.disabled = false;
          statusReady(currentPreset);
        }
      }

      spinBtn.addEventListener('click', function () {
        if (isPlaying) {
          stopAudio();
          return;
        }
        if (currentPreset && !isSpinning) {
          startAudio(currentPreset);
          return;
        }
        doSpin();
      });

      if (resetBtn) {
        resetBtn.addEventListener('click', function () {
          if (isSpinning) return;
          stopAudio();
          currentPreset = null;
          resetBtn.disabled = true;
          doSpin();
        });
      }

      /* 波形 canvas：播放时三层正弦波，闲时低幅呼吸 */
      if (canvas) {
        var ctx2d = canvas.getContext('2d');
        function resizeCanvas() {
          canvas.width = canvas.offsetWidth * devicePixelRatio;
          canvas.height = canvas.offsetHeight * devicePixelRatio;
          ctx2d.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, 0, 0);
        }
        resizeCanvas();
        window.addEventListener('resize', resizeCanvas);
        function drawWave() {
          requestAnimationFrame(drawWave);
          var w = canvas.offsetWidth;
          var h = canvas.offsetHeight;
          if (!w || !h) return;
          ctx2d.clearRect(0, 0, w, h);
          var BARS = 40;
          var bw = 2;
          var gap = (w - BARS * bw) / (BARS - 1);
          var color = (currentPreset && currentPreset.color) || '#675cff';
          var i;
          if (isPlaying) {
            for (i = 0; i < BARS; i++) {
              var val = 0.35 + (Math.sin(playPhase * 1.3 + i * 0.35) + Math.sin(playPhase * 2.1 + i * 0.6) * 0.5 + Math.sin(playPhase * 0.7 + i * 0.9) * 0.3) * 0.22;
              var bh = Math.max(3, h * Math.max(0.05, val));
              var alpha = Math.round((0.4 + val * 0.5) * 255).toString(16).padStart(2, '0');
              ctx2d.fillStyle = color + alpha;
              ctx2d.beginPath();
              ctx2d.roundRect(i * (bw + gap), (h - bh) / 2, bw, bh, 1);
              ctx2d.fill();
            }
            playPhase += 0.08;
          } else {
            for (i = 0; i < BARS; i++) {
              var ibh = Math.max(2, h * (0.05 + 0.04 * Math.sin(idlePhase + i * 0.42)));
              ctx2d.fillStyle = 'rgba(255,255,255,0.07)';
              ctx2d.beginPath();
              ctx2d.roundRect(i * (bw + gap), (h - ibh) / 2, bw, ibh, 1);
              ctx2d.fill();
            }
            idlePhase += 0.022;
          }
        }
        drawWave();
      }

      // 初次进入面板自动转一次（对齐旧站 doSpin() 初始化）
      doSpin();

      return {
        stop: function () {
          stopAudio();
        }
      };
    }

    /* ── tab 切换 ───────────────────────────────────────── */
    function showPanel(key, focusTab) {
      var nextTab = tabs.find(function (t) { return t.dataset.waysTab === key; });
      var nextPanel = panels.find(function (p) { return p.dataset.waysPanel === key; });
      if (!nextTab || !nextPanel) return;

      stopAllMedia();
      activeKey = key;
      tabs.forEach(function (tab) {
        var active = tab === nextTab;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach(function (panel) {
        var active = panel === nextPanel;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });

      if (nextPanel.hasAttribute('data-ways-jam-panel') && !jam) {
        jam = createJam();
      }
      playPanelVideo(nextPanel);
      if (focusTab) nextTab.focus();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        showPanel(tab.dataset.waysTab);
      });
      tab.addEventListener('keydown', function (e) {
        var next = index;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (index + 1) % tabs.length;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = tabs.length - 1;
        if (next === index) return;
        e.preventDefault();
        showPanel(tabs[next].dataset.waysTab, true);
      });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visible = entry.isIntersecting;
          if (!visible) {
            stopAllMedia();
            return;
          }
          playPanelVideo(panels.find(function (p) { return p.dataset.waysPanel === activeKey; }));
        });
      }, { threshold: 0.16 }).observe(section);
    } else {
      visible = true;
      playPanelVideo(panels[0]);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') stopAllMedia();
      else if (visible) playPanelVideo(panels.find(function (p) { return p.dataset.waysPanel === activeKey; }));
    });
  }

  function init() {
    document.querySelectorAll('[data-ways]').forEach(function (section) {
      if (section.dataset.waysReady === 'true') return;
      section.dataset.waysReady = 'true';
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
